import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import VehicleTransferLocation from '../../views/location/VehicleTransferLocation';
const objectTypes = ['locator', 'vehicle'];
export default {
  id: 'recovr.vehicle.TransferLocation',
  name: 'Transfer to New Location',
  layout: {
    sort: 'item.zzzzTransfer'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: ['location.locators', 'location.vehicles', 'company.vehicles', 'company.locators', 'company.locations.vehicles', 'company.locations.locators'],
    objectType: objectTypes
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  handles: cxt => {
    const targets = Context.getTarget(cxt);
    if (!targets) {
      return false;
    }
    return objectTypes.includes(targets?.type);
  },
  appearance: ({
    context
  }) => {
    return {
      name: 'Transfer to New Location',
      icon: 'fa fa-exchange'
    };
  },
  perform: data => {
    const {
      context
    } = data;
    const {
      clientProps
    } = context;
    const targetKey = clientProps.targetKey;
    const targets = Context.getTargets(context);
    const type = targets[0].type;
    const typeUpperCase = type[0].toUpperCase() + type.slice(1);
    Dialogs.show({
      component: VehicleTransferLocation,
      props: {
        targets,
        dispatch: context.clientProps.dispatch,
        parentItem: context.clientProps.parentItem,
        reloadData: context.reloadData || clientProps.reloadData,
        targetKey,
        type,
        typeUpperCase
      }
    });
  }
};